'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiMediaRecord = function TiMediaRecord(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 20c0-2.8-1.1-5.3-2.9-7.1-1.8-1.8-4.3-2.9-7.1-2.9-2.8 0-5.3 1.1-7.1 2.9-1.8 1.8-2.9 4.3-2.9 7.1 0 2.8 1.1 5.3 2.9 7.1s4.3 2.9 7.1 2.9c2.8 0 5.3-1.1 7.1-2.9 1.8-1.8 2.9-4.3 2.9-7.1z' })
        )
    );
};

exports.default = TiMediaRecord;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/media-record.js
// module id = 3142
// module chunks = 0